/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Tooltip, IconButton, Paper, Popper, Typography, Divider, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, ExpansionPanelActions, Button, ClickAwayListener, Avatar } from '@material-ui/core'
import { ExitToAppOutlined, ArrowRightAlt, Clear, ExpandMore } from '@material-ui/icons'

import { format } from 'date-fns'
import { zonedTimeToUtc } from 'date-fns-tz'

import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import {
  DateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'

import SecureWrapper from "../../Security/SecureWrapper";

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({

})

class DataTransfer extends Component {
    state = {
        enabled : true,
        open : false,
        anchorEl : null,
        disable_clear : false,
        disable_incrementa : false,
        clear_start_date : null
    }

    arrowRef = React.createRef()

    componentDidMount() {
        
    }

    getEnabledState = (ic_data, entity) => {

    }

    isICReadyForTransfer = () => {

    }

    isIUReadyForTransfer = () => {

    }

    updateStartDate = (date) => {
        let start_date =  format(date, "yyyy-MM-dd'T'HH:mm:ssxxx")
        this.setState({
            ...this.state,
            clear_start_date : start_date
        })
    }

    togglePopover = (event) => {
        console.log("AnchorEl: ", event.currentTarget)
        if (this.state.open) {
            this.setState({...this.state, anchorEl : null, open : false})
        } else {
            this.setState({...this.state, anchorEl : event.currentTarget, open : true})
        }
    }

    handleClose = () => {
        this.setState({...this.state, anchorEl : null, open : false})
    }

    clickAway = () => {
        if (this.state.open) {
            this.setState({...this.state, anchorEl : null, open : false})
        }
    }

    transferData = (type, entity, entity_name) => {
        let transfer_object = this.generateTransferObject(type, entity, entity_name)
        if (type === 'Clean') {
            transfer_object = this.cleanTransfer(transfer_object, )
        } else if (type === 'Incremental') {
            transfer_object = this.incrementalTransfer(transfer_object, entity, entity_name)
        }

        console.log("Transferring Data : ", transfer_object)
        this.setState({...this.state, open : false}, () => {
            this.props.transfer_data(transfer_object, entity, entity_name)
        })
    }

    generateTransferObject = (type, entity, entity_name) => {
        let transfer_object = {
            ic_name : null,
            iu_names : [],
            time_filters : [],
            type : null
        }

        if (entity === "ic") {
            transfer_object.ic_name = entity_name
            transfer_object.iu_names = this.props.ic_data.information_units.map(iu => iu.name)
        }

        if (entity === 'iu') {
            transfer_object.ic_name = this.props.ic_data.name
            transfer_object.iu_names = [entity_name]
        }

        return transfer_object
    }

    cleanTransfer = (transfer_object) => {
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        console.log("Current Time Zone : ", timezone )

        let time_filter = {
            start_time : zonedTimeToUtc(format(new Date(this.state.clear_start_date),'yyyy-MM-dd HH:mm:ss'), timezone).toISOString(),
            end_time : zonedTimeToUtc(format(new Date(),'yyyy-MM-dd HH:mm:ss'), timezone).toISOString()
        }

        transfer_object.time_filters.push(time_filter)
        transfer_object.type = "Clean"

        return transfer_object
    }

    incrementalTransfer = (transfer_object, entity, entity_name) => {
        let time_filter = {
            start_time : null,
            end_time : format(new Date(), "yyyy-MM-dd'T'HH:mm:ssxxx")
        }

        if (entity === "ic") {
            time_filter.start_time = this.props.ic_data.last_data_transfer_date
        } else if (entity === "iu") {
            let iu_object = this.props.ic_data.information_units.find(iu => iu.name === entity_name)
            time_filter.start_time = iu_object.last_data_transfer_date
        }
        
        // transfer_object.time_filters.push(time_filter)
        transfer_object.type = "Incremental"

        return transfer_object
    }

    renderPopOver = () => {
        const { classes } = this.props
        return (
            <Popper
                key = {"popper"}
                open={this.state.open}
                anchorEl={this.state.anchorEl}
                // onClose={this.handleClose}
                placement="bottom-end"
                modifiers={{
                    flip: {
                        enabled: true,
                    },
                    preventOverflow: {
                        enabled: false,
                        boundariesElement: 'scrollParent',
                    }
                }}
            >
                <ClickAwayListener onClickAway = {this.handleClose}>
                    <Paper elevation = {6} style = {{backgroundColor : "#FAFBFC", width : '30vw'}}>
                        <div style = {{width : '30vw', padding : '2%'}}>
                            <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                <div>
                                    <Avatar style = {{backgroundColor : '#2296f3', marginRight : '10px'}}>
                                        <ExitToAppOutlined style = {{color : '#FFFFFF'}} fontSize = 'small'/>
                                    </Avatar>
                                </div>
                                <div style = {{flexGrow : 1}}>
                                    <Typography variant = 'subtitle2'>Data Transfer</Typography>
                                    <Typography variant = 'caption' color = 'textSecondary'>{this.props.ic_data.name}</Typography>
                                </div>
                                <div>
                                    <IconButton style = {{marginLeft : '10px'}} size = 'small' color = 'secondary' onClick = {this.handleClose}>
                                        <Clear fontSize = 'small'/>
                                    </IconButton>
                                </div>
                            </div>
                        </div>
                        <Divider/>
                        {this.renderClear()}
                        {this.renderIncremental()}
                    </Paper>
                </ClickAwayListener>
            </Popper>
        )
    }

    renderClear = () => {
        return (
            <ExpansionPanel>
                <ExpansionPanelSummary
                    style = {{borderBottom : '1px solid rgba(0,0,0,0.12)'}}
                    expandIcon={<ExpandMore />}
                >
                    <Typography variant = 'subtitle2' color = 'primary'>Fresh Import</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography variant = 'body2'>This action will delete all previously transferred data and starts a fresh import. Use this action to import data for the first time.</Typography>
                </ExpansionPanelDetails>
                <div style = {{width : '100%', padding : '20px', display : 'flex', flexDirection : 'row', justifyContent : 'center'}}>
                    <Typography variant = 'body2' color = 'textSecondary'>Select the date and time from when the data has to be considered.</Typography>
                </div>
                <div style = {{width : '100%', padding : '20px',display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <div style = {{flexGrow : 1, padding : '10px'}}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DateTimePicker
                                fullWidth
                                disableFuture
                                label = "Start Date"
                                value={this.state.clear_start_date}
                                onChange={(value) => {
                                    this.updateStartDate(value)
                                }}
                                helperText="Choose Start Date and Time"
                                format="yyyy/MM/dd HH:mm"
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    <div>
                        <ArrowRightAlt color = 'primary'/>
                    </div>
                    <div style = {{flexGrow : 1, padding : '10px', wordWrap : 'break-word', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                        <div>
                            <Typography style = {{display : 'block'}} variant = 'subtitle2'>Now</Typography>
                            <Typography variant = 'caption' color ='textSecondary'>{format(new Date(), "EEE LLL do yyyy 'at' HH:mm:ss zzz")}</Typography>
                        </div>
                    </div>
                </div>
                <Divider/>
                <ExpansionPanelActions>
                <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/information_channel",
                        method : "POST",
                        operands : []
                      }}
                    >
                    <Button 
                        variant = 'contained'
                        color = 'primary'
                        endIcon = {<ArrowRightAlt/>}
                        size = 'small'
                        disabled = {this.state.clear_start_date !== null ? false : true}
                        onClick = {() => this.transferData('Clean', this.props.entity, this.props.entity_name)}
                    >
                        Initiate Transfer
                    </Button>
                    </SecureWrapper>
                </ExpansionPanelActions>
            </ExpansionPanel>
        )
    }

    renderIncremental = () => {
        return (
            <ExpansionPanel disabled = {this.props.ic_data.last_data_transfer_date === null ? true : false}>
                <ExpansionPanelSummary
                    style = {{borderBottom : '1px solid rgba(0,0,0,0.12)'}}
                    expandIcon={<ExpandMore />}
                >
                    <Typography variant = 'subtitle2' color = 'primary'>Import latest data</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography variant = 'body2'>This action will import all the data from the last data transfer date.</Typography>
                </ExpansionPanelDetails>
                <div style = {{width : '100%', padding : '20px',display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <div style = {{flexGrow : 1, padding : '10px', wordWrap : 'break-word', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                        <div>
                            <Typography style = {{display : 'block'}} variant = 'subtitle2'>Last Transfer Date</Typography>
                            <Typography variant = 'caption' color ='textSecondary'>{format(new Date(this.props.ic_data.last_data_transfer_date), "EEE LLL do yyyy 'at' HH:mm:ss zzz")}</Typography>
                        </div>
                    </div>
                    <div>
                        <ArrowRightAlt color = 'primary'/>
                    </div>
                    <div style = {{flexGrow : 1, padding : '10px', wordWrap : 'break-word', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                        <div>
                            <Typography style = {{display : 'block'}} variant = 'subtitle2'>Now</Typography>
                            <Typography variant = 'caption' color ='textSecondary'>{format(new Date(), "EEE LLL do yyyy 'at' HH:mm:ss zzz")}</Typography>
                        </div>
                    </div>
                </div>
                <Divider/>
                <ExpansionPanelActions>
                <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/information_channel",
                        method : "POST",
                        operands : []
                      }}
                    >
                    <Button 
                        variant = 'contained'
                        color = 'primary'
                        endIcon = {<ArrowRightAlt/>}
                        size = 'small'
                        onClick = {() => this.transferData('Incremental', this.props.entity, this.props.entity_name)}
                    >
                        Initiate Transfer
                    </Button>
                    </SecureWrapper>
                </ExpansionPanelActions>
            </ExpansionPanel>
        )
    }

    render() { 
        const { classes } = this.props
        return (
            <Fragment>
                <ThemeProvider theme = {blue_theme}>
                    <Tooltip title="Initiate Data Transfer" arrow>
                        <IconButton
                            color = 'primary'
                            size = 'small'
                            disabled = {!this.state.enabled}
                            onClick = {(event) => this.togglePopover(event)}
                        >
                            <ExitToAppOutlined fontSize = 'small'/>
                        </IconButton>
                    </Tooltip>
                    {this.renderPopOver()}
                </ThemeProvider>
            </Fragment>
        );
    }
}
 
export default withStyles(styles)(DataTransfer);